var explore = (function() {
	'use strict';

	var _autoHeightAnimate = function(element, time) {
		var curHeight = element.height();
		var autoHeight = element.css('height', 'auto').height();

		element.height(curHeight);
		element.stop().animate({ height: autoHeight }, time);
	};

	function init() {
		var animateTime = 500;
		var trigger = $('.explore__column');

		trigger.click(function(){
			if ($(window).width() < 768) {
				var el = $(this).find('.explore__hidden');

				if(el.height() === 0){
					$('.explore__expand',this).toggleClass('hidden');
					_autoHeightAnimate(el, animateTime);
				} else {
					$('.explore__expand',this).toggleClass('hidden');
					el.stop().animate({ height: '0' }, animateTime);
				}
			}
		});
	}

	return {
		init:init
	};
}());

jQuery(document).ready(function($) {
	explore.init();
});